/** Words used all over the interface. */
export default {
  Language: "Dil",
  English: "İngilizce",
  Close: "Kapat",
  Cancel: "Vazgeç",
  OK: "Tamam",
  "Character panels": "Karakter panelleri",
} satisfies Record<string, string>;
